<style lang="scss" scoped>
.degreebar {
  transition: 0.2s all;
  cursor: pointer;
  border: 1px solid $c-dark-blue;
  background-color: $c-dark-blue;
  margin-top: 50px;
  & + .degreebar {
    margin-top: 10px;
  }
  padding: 15px;
  .col-12 {
    text-align: center;

    color: $c-light-gray;
    text-decoration: none;
  }

  &:hover {
    background-color: $c-light-gray;
    .col-12 {
      color: $c-dark-blue;
    }
  }
}
</style>

<template>
  <router-link :to="{ name: 'FeedbackSelf' }" custom v-slot="{ navigate }" v-if="showMine">
    <div class="container-fluid degreebar" @click="navigate">
      <div class="row">
        <div class="col-12">SIE HABEN NOCH IHRE SELBSTEINSCHÄTZUNG OFFEN!</div>
      </div>
    </div>
  </router-link>

  <router-link :to="{ name: 'Feedback' }" custom v-slot="{ navigate }">
    <div class="container-fluid degreebar" v-if="count > 0" @click="navigate">
      <div class="row">
        <div class="col-12">
          SIE HABEN NOCH {{ countUsers > 1 ? countUsers : 'EINE' }} OFFENE
          {{ countUsers > 1 ? 'SKILLSEINSCHÄTZUNGEN VON MITARBEITER:INNEN' : 'SKILLSEINSCHÄTZUNG EINES:R MITARBEITERS:IN' }}. JETZT EVALUIEREN!
        </div>
      </div>
    </div>
  </router-link>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  setup() {
    const store = useStore();
    const count = ref(0);
    const countUsers = ref(0);
    const showMine = ref(false);

    store.dispatch('fetchOpenFeedbacks').then((res: any) => {
      if (res.data.message) {
        count.value = parseInt(res.data.message.count);
        countUsers.value = res.data.message.users.length;
        showMine.value = Object.keys(res.data.message.mine).length > 0;
      }
    });

    return {
      count,
      countUsers,
      showMine,
    };
  },
});
</script>
